import ActionRequiredInvoicesContextProvider from 'src/sections/action_required_invoices/ActionRequiredInvoicesContext';
import ActionRequiredInvoicesMain from 'src/sections/action_required_invoices/ActionRequiredInvoicesMain';
import ActionRequiredInvoicesNavBar from 'src/sections/action_required_invoices/ActionRequiredInvoicesNavBar';
import 'src/style/ActionRequiredInvoices.scss';

function ActionRequiredInvoices() {
  return (
    <ActionRequiredInvoicesContextProvider>
      <ActionRequiredInvoicesNavBar />
      <ActionRequiredInvoicesMain />
    </ActionRequiredInvoicesContextProvider>
  );
}

export default ActionRequiredInvoices;
